import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import Products from './pages/Products';
import Impressum from './pages/Impressum';
import NotFound from './pages/NotFound';
import 'flowbite/dist/flowbite.min.js';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import client from './Client';
import AOS from "aos";
import "aos/dist/aos.css";

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [products, setProducts] = useState([]);
  const [faqEntries, setFaqEntries] = useState([]);

  useEffect(() => {
    AOS.init({
  offset: 120,
  delay: 0,
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  mirror: false,
  anchorPlacement: 'top-bottom',
});
    AOS.refresh();
  }, []);

  useEffect(() => {
    client.getEntries({ content_type: 'product'})
      .then((response) => setProducts(response.items))
      .catch(console.error);

    client.getEntries({content_type: 'faq'})
      .then((response) => setFaqEntries(response.items))
      .catch(console.error);
  }, [])

  return (
    <div className="flex-grow overflow-x-clip relative">
      <BrowserRouter>
      <ScrollToTop />
      <Navigation />
        <Routes>
          <Route index element={<Home faqEntries={faqEntries} />} />
          <Route path="datenschutz" element={<Privacy />} />
          <Route path="kontakt" element={<Contact />} />
          <Route path="produkte" element={<Products products={products} />} />
          <Route path="impressum" element={<Impressum />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      <Footer />
      </BrowserRouter>
      </div>
  );
}

export default App;
